import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <p className='footer__text'>Created By Amir Kobaisse</p>
  </footer>
)

export default Footer

